module.exports = __webpack_public_path__ + "static/scale-model-of-old-sugar-distillery-in-madison-wisconsin-910917d6d647ae752fedd52fb030b268.png";